import { createSelector } from 'reselect'

export const getBoardId = (state, props) => {
  return props.boardContext.id
}

export const getCard = (state, props) => {
  return state['view-board'].cards[props.id]
}

export const getAllowCardRemove = (state, props) => {
  return state['view-board'].settings[props.boardContext.id].allowCardRemove
}

export const getMyBoardEnabled = (state, props) => {
  return state.kanbo.config.myBoard
}

const createIsObservedSelector = () => createSelector(
  [
    (_, { id }) => id,
    state => state.kanbo.observedTags,
  ],
  (
    cardId,
    observedTags,
  ) =>
    observedTags.some(tag => tag === `card-${cardId}`)
)

export default createSelector(
  [
    getBoardId,
    getCard,
    getAllowCardRemove,
    getMyBoardEnabled,
    createIsObservedSelector(),
  ],
  (
    boardId,
    card,
    allowCardRemove,
    myBoardEnabled,
    isObserved,
  ) => ({
    boardId,
    name: card.name,
    allowCardRemove,
    myBoardEnabled,
    isObserved,
  })
)
